// @flow

import React from 'react';
import Tooltip from '@homeaway/react-tooltip';

type Props = {
    helpText: string,
    isDesktop: boolean,
    onHelpClick: () => void,
    onHelpTextClose: () => void,
};

const VaHelpText = ({
    helpText,
    isDesktop,
    onHelpClick,
    onHelpTextClose,
}: Props) => {
    return (
        <div className="va-floating__help-text">
            <Tooltip
                closeOnOutsideClick={false}
                content={<div onClick={onHelpClick}>{helpText}</div>}
                isOpen
                onClose={onHelpTextClose}
                placement={isDesktop ? 'left' : 'top'}
                portalClassName="va-floating__tooltip"
                shouldPersist
                tooltipType="popover"
                trigger="none"
            />
        </div>
    );
};

export default VaHelpText;
